import { IsMongoId } from 'class-validator';

import { UpdateDraftDto } from './update-draft.dto';

export class UpdateDraftItemDto extends UpdateDraftDto {
  @IsMongoId()
  public id: string;
}
